import { deep as theme, swiss, future, dark } from '@theme-ui/presets/';

export default {
  ...theme,
  initialColorModeName: 'deep',
  colors: {
    ...theme.colors,
    modes: {
      deep: { ...theme.colors },
      swiss: { ...swiss.colors },
      future: { ...future.colors },
      dark: { ...dark.colors },
    },
  },
  button: {
    hollow: {
      bg: 'background',
      border: (theme) => `3px solid ${theme.colors.primary}`,
      borderRadius: 10,
      color: 'text',
      display: 'inline-block',
      fontFamily: 'heading',
      fontWeight: 'bold',
      p: 2,
      textDecoration: 'none',
      transition: '200ms linear background',
      ':focus': {
        bg: 'highlight',
        outline: (theme) => `2px solid ${theme.colors.secondary}`,
        outlineOffset: 2,
      },
      ':hover': {
        bg: 'highlight',
        border: (theme) => `3px solid ${theme.colors.secondary}`,
      },
    },
    primary: {
      bg: 'primary',
      border: (theme) => `3px solid ${theme.colors.primary}`,
      color: 'background',
      borderRadius: 10,
      display: 'inline-block',
      fontFamily: 'heading',
      fontWeight: 'bold',
      py: 1,
      px: 2,
      textDecoration: 'none',
      transition: '200ms linear background',
      ':focus': {
        bg: 'secondary',
        outline: (theme) => `2px solid ${theme.colors.secondary}`,
        outlineOffset: 2,
      },
      ':hover': {
        bg: 'secondary',
        border: (theme) => `3px solid ${theme.colors.text}`,
      },
    },
  },
  taxonomy: {
    regular: {
      my: 0,
    },
  },
  list: {
    blogroll: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      li: {
        borderBottom: (theme) => `2px solid ${theme.colors.primary}`,
        display: 'flex',
        width: '100%',
        flexDirection: 'column-reverse',
        pb: 3,
        mb: 3,
        '&:last-child': {
          borderBottom: (theme) => `none`,
        },
        '.taxonomy': {
          mt: 0,
          mb: 1,
          fontStyle: 'italic',
          fontSize: '1rem',
        },
        '.timestamp': {
          minWidth: '25%',
          fontStyle: 'italic',
          fontSize: '1rem',
        },
        'h2, h4': {
          mt: 0,
          mb: 1,
        },

        '@media screen and (min-width: 768px)': {
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'baseline',
          '.timestamp': {
            textAlign: 'right',
          },
        },
      },
    },
  },
};
